import { useFormikContext } from 'formik';
import { isDefined } from 'Utils/type.utils';
import { CancelFormValues } from './CancelFormV2/cancelForm.types';
import { ChangeFormValues } from './ChangeForm/changeForm.types';
import { UseFormStatus, UseFormValues } from './forms.types';

export const useFormStatus = (): UseFormStatus => {
  const { status, errors, isSubmitting } = useFormikContext();
  const notSubmitted = !status?.submit;
  const submitSuccess = status?.submit === 'success';
  const submitError = status?.submit === 'error';
  const priceError = status?.priceCalculation === 'error';
  const isCalculatingPrice = status?.priceCalculation === 'calculating';
  const hasFormErrors = isDefined(errors) && Object.keys(errors).length > 0;

  return {
    notSubmitted,
    submitSuccess,
    submitError,
    priceError,
    isCalculatingPrice,
    isSubmitting,
    hasFormErrors,
  };
};

export const useFormValues = (): UseFormValues => {
  const { values } = useFormikContext<ChangeFormValues | CancelFormValues>();
  return values;
};
